import type { FC, PropsWithChildren } from "react";

import { Card } from "@jti/core-components/components/Card";
import { Loader } from "@jti/core-components/components/Loader";
import { Separator } from "@jti/core-components/components/Separator";
import { useTranslations } from "@jti/ui";

import { OrderSummaryPageWarningMessage } from "@checkout/pages/OrderSummaryPage/components/OrderSummaryPageWarningMessage";

import Prices from "../Prices/Prices";

import styles from "./PaymentSummaryBase.module.scss";

export type PaymentSummaryBaseProps = {
  isPricesLoading: boolean;
  isFreeTrial?: boolean;
  prices?: any; // TODO: fix type
};

export const PaymentSummaryBase: FC<PropsWithChildren<PaymentSummaryBaseProps>> = ({
  isPricesLoading,
  prices,
  isFreeTrial = false,
  children,
}) => {
  const { __ } = useTranslations();

  return (
    <>
      <Card variant="level-2">
        <section>
          <header className={styles.summaryHeader}>
            <h2 className={styles.title}>{__("cart.payment_summary.title")}</h2>
            {isPricesLoading && (
              <div className={styles.loadingIndicator}>
                <Loader />
              </div>
            )}
          </header>

          <div className={styles.separator}>
            <Separator />
          </div>

          {prices && <Prices prices={prices} isSummary isFreeTrial={isFreeTrial} className={styles.noMargin} />}

          {children}
        </section>
      </Card>

      <OrderSummaryPageWarningMessage className={styles.trialMessage} isFreeTrial={isFreeTrial} />
    </>
  );
};
